import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';

function SBInvoiceListPageActions() {
  const navigate = useNavigate();
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();

  const handleCreateAction = () => {
    if (!checkSubscription()) {
      return;
    }
    return navigate('/self-billed-documents/invoices/create');
  };

  return (
    <>
      <Button
        id="create-sb-invoice"
        key="create-new-invoice"
        variant="contained"
        color="primary"
        onClick={handleCreateAction}
      >
        + Create Self-Billed Invoice
      </Button>
      <SubscriptionModal />
    </>
  );
}

export default SBInvoiceListPageActions;
